import React, { useEffect, useRef, useState } from 'react';
import { playTone } from './posFeedback';
import { useLanguage } from '../../context/LanguageContext';
import './Pos.css';

const DeskStation = ({
  title,
  hint,
  options,
  selected,
  onSelect,
  extra,
  onScan,
}) => {
  const { t } = useLanguage();
  const inputRef = useRef(null);
  const timerRef = useRef(null);
  const [query, setQuery] = useState('');
  const [overlay, setOverlay] = useState(null);

  useEffect(() => {
    inputRef.current?.focus();
    return () => clearTimeout(timerRef.current);
  }, []);

  const focusScan = () => inputRef.current?.focus();

  const onBlur = (event) => {
    const next = event.relatedTarget;
    if (!next) {
      setTimeout(focusScan, 0);
      return;
    }
    const tag = next.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'BUTTON' || tag === 'A') {
      return;
    }
    setTimeout(focusScan, 0);
  };

  const showResult = (result) => {
    setOverlay(result);
    playTone(result.color === 'green' ? 'ok' : 'bad');
    const wait = result.color === 'green' ? 1200 : 2000;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setOverlay(null);
      focusScan();
    }, wait);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const value = query.trim();
    if (!value || !selected) return;
    setQuery('');
    try {
      showResult(await onScan(value));
    } catch (err) {
      showResult({
        color: 'red',
        message: err.response?.data?.error || t('desk.failed'),
        code: 'error',
      });
    }
    focusScan();
  };

  return (
    <div className="pos-station">
      <h1>{title}</h1>
      <p className="pos-hint">{hint}</p>
      <select
        className="pos-station-select"
        value={selected}
        onChange={(event) => onSelect(event.target.value)}
      >
        <option value="">{t('desk.choose')}</option>
        {options}
      </select>
      {extra}
      <form onSubmit={onSubmit}>
        <input
          ref={inputRef}
          className="pos-scan-input"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onBlur={onBlur}
          placeholder={t('desk.scanPh')}
          aria-label={t('desk.scanLabel')}
          autoComplete="off"
          autoFocus
        />
      </form>
      {overlay && (
        <div className={`pos-overlay ${overlay.color}`} role="status">
          <div>
            <h2>{(() => {
              if (!overlay.code) return overlay.message;
              const key = `desk.${overlay.code}`;
              const translated = t(key);
              return translated === key ? overlay.message : translated;
            })()}</h2>
            {overlay.member && (
              <>
                <p>{overlay.member.chinese_name}</p>
                <p>{overlay.member.member_number}</p>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DeskStation;
